var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("首页")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("售后订单列表")])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "swb-back-row" },
      [
        _c("div", { staticClass: "order-title mb10" }, [
          _c("div", { staticClass: "order-title-content fl" }, [
            _vm.flag
              ? _c("ul", { staticClass: "order-status" }, [
                  _c("li", {}, [
                    _vm._v("零售商名称：" + _vm._s(_vm.contranct.fstPartyName))
                  ]),
                  _vm._v(" "),
                  _c("li", {}, [
                    _vm._v("合同编号：" + _vm._s(_vm.contranct.fstPartyHtBh))
                  ]),
                  _vm._v(" "),
                  _vm.contranct.confirmed
                    ? _c("li", [_vm._v("合同状态：合同履约中")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contranct.fullfilled
                    ? _c("li", {}, [_vm._v("合同状态：履约完成")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contranct.checked
                    ? _c("li", {}, [_vm._v("合同状态：已验收")])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("swb-servc-order-search", {
          attrs: { no: _vm.no, after: false },
          on: { showAfterServcOrderSearch: _vm.afterServcOrderSearch }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "orders-list-container" }, [
          _c(
            "table",
            { staticClass: "orders-list-panel1" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._l(_vm.servOrderList, function(servcOrder, index) {
                return _vm.servOrderList != null && _vm.servOrderList.length > 0
                  ? _c("tbody", { staticClass: "orders-body" }, [
                      _vm._m(2, true),
                      _vm._v(" "),
                      _c("tr", { staticClass: "abstract-row" }, [
                        _c("td", { attrs: { colspan: "6" } }, [
                          _c("div", { staticClass: "abstract-content" }, [
                            _c("span", { staticClass: "mr5 font-black" }, [
                              _vm._v("订单号:" + _vm._s(servcOrder.no))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "mr5 font-black" }, [
                              _vm._v(_vm._s(servcOrder.createTime))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "swb-btn-link mt5",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.toTradeVoucherList(servcOrder.tradeNo)
                                  }
                                }
                              },
                              [_vm._v("交易单号:" + _vm._s(servcOrder.tradeNo))]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "mr5 font-black" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "mr5 font-black" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "mr5 font-black" })
                          ]),
                          _vm._v(" "),
                          servcOrder.proxied
                            ? _c("div", { staticClass: "table-tips order" })
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "info-row" }, [
                        _c(
                          "td",
                          _vm._l(servcOrder.itemList, function(
                            servcOrderItem,
                            index
                          ) {
                            return servcOrder.itemList != null &&
                              servcOrder.itemList.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "goods-info-block",
                                    staticStyle: { overflow: "hidden" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "goods-item clearfix" },
                                      [
                                        _c("div", { staticClass: "good-img" }, [
                                          servcOrderItem.servcFileBrowseUrl !=
                                          null
                                            ? _c("img", {
                                                staticClass: "wh100",
                                                attrs: {
                                                  src:
                                                    servcOrderItem.servcFileBrowseUrl
                                                }
                                              })
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "good-msg" }, [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "ellipsis-2 font12 align-left"
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(servcOrderItem.title)
                                                )
                                              ])
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          })
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", [
                            _c("div", { staticClass: "font14 align-left" }, [
                              _vm._v(_vm._s(servcOrder.servicerName))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "font14 align-left" }, [
                              _vm._v(
                                "预约上门时间:" + _vm._s(servcOrder.planTime)
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", { staticClass: "font-gray1" }, [
                            _c("span", [
                              _vm._v("总额 ¥"),
                              _c("b", { staticClass: "pri" }, [
                                _vm._v(
                                  _vm._s(
                                    parseFloat(servcOrder.amount).toFixed(2)
                                  )
                                )
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          servcOrder.servicerShopFlag == true
                            ? _c("div", [
                                _vm._v(_vm._s(servcOrder.servicerShopName))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          servcOrder.workAssignStateX != null
                            ? _c("div", { staticClass: "font14 font-gray2" }, [
                                _c("span", [
                                  _vm._v(
                                    "派工状态:" +
                                      _vm._s(
                                        _vm.workAssignStateX[
                                          servcOrder.workAssignStateX
                                        ]
                                      )
                                  )
                                ])
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          servcOrder.state != null
                            ? _c("div", { staticClass: "font14 font-gray2" }, [
                                _vm._v(_vm._s(servcOrder.state))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkActionPerm("view_detail")
                            ? _c(
                                "div",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.searchOrder(servcOrder.id)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "icon iconfont" }),
                                  _c("span", [_vm._v("订单详情")])
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm.checkActionPerm("cancel") &&
                          servcOrder.cancellable &&
                          !servcOrder.cancelled
                            ? _c(
                                "div",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.doCancalServcOrder(servcOrder.id)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v("取消")])]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkActionPerm("initiate_complaint")
                            ? _c(
                                "div",
                                {
                                  staticClass: "swb-btn swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.complaintSave(servcOrder.id)
                                    }
                                  }
                                },
                                [_c("span", [_vm._v("发起投诉")])]
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  : _vm._e()
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "block pagination-layout" },
          [
            _c("el-pagination", {
              staticClass: "mt10",
              attrs: {
                background: "",
                "page-size": _vm.pageSize,
                "page-sizes": _vm.pageSizes,
                "current-page": _vm.pageNumber,
                total: _vm.totalCount,
                layout: "total, sizes, prev, pager, next, jumper"
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "350px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "250px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "150px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "150px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100px" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "100px" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "orders-header" }, [
      _c("tr", {}, [
        _c("th", [_vm._v("服务信息")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "text-align": "left" } }, [
          _vm._v("服务商信息")
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("金额")]),
        _vm._v(" "),
        _c("th", [_vm._v("交易状态")]),
        _vm._v(" "),
        _c("th", [_vm._v("交付状态")]),
        _vm._v(" "),
        _c("th", [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "blank-row" }, [
      _c("td", { attrs: { colspan: "6" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ba68a1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba68a1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servcOrder/AfterSaleOrderList.vue
// module id = 2870
// module chunks = 0